import { AuthService, HomeComponent, TermsAndConditionService } from '@accesso/adk-portal-shared';
import { Component, OnInit, inject } from '@angular/core';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    imports: [HomeComponent]
})
export class LandingComponent implements OnInit {
  private authService = inject(AuthService);
  private termsAndConditionService = inject(TermsAndConditionService);

  isUserLoggedIn = false;
  acceptedLatestTerms = false;

  ngOnInit(): void {
    this.isUserLoggedIn = this.authService.isLoggedIn;
    this.acceptedLatestTerms = this.termsAndConditionService.acceptedLatestTerms;
  }
}
